import React, {FC, PropsWithChildren} from 'react';
import {Navigate, useLocation} from "react-router-dom";
import {useIsAuthenticated} from "@/features/identity/hooks/useIsAuthenticated.ts";

const ProtectedRoute: FC<PropsWithChildren> = ({children}) => {
    const isAuthenticated = useIsAuthenticated();
    const location = useLocation();

    if (!isAuthenticated) {
        return <Navigate to={`/auth/login?returnUrl=${encodeURIComponent(location.pathname + location.search)}`}/>
    }

    return (
        <>
            {children}
        </>
    );
};

export default ProtectedRoute;